module.exports = __webpack_public_path__ + "media/icons/time@3x-35707170.svg";